import React from 'react';
import CategoryItem from '../sections/CategoryItem';
import '../CategoryChoice.css'

const CategoryList = ({ categories = [], type }) => {
  // Для отладки
  console.log('CategoryList рендер:', {
    type,
    categoriesLength: categories.length,
    categories: categories
  });
  
  if (!categories || categories.length === 0) {
    return <div>Категории не найдены</div>;
  }

  return (
    <div id="tagsWrapper" className="category-list-container">
      {categories.map(category => (
        <CategoryItem 
          key={category.id}
          category={category}
          type={type}
        />
      ))}
    </div>
  );
};

export default CategoryList;